import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCuentaContableCuentaVenta } from "api/CuentaContable_Cuenta.hook"
import { CATEGORIA_CUENTA_CONTABLE_ENUM } from "api/Types/CategoriaCuentaContableEnum"
import Button from "common/components/Button/Button"
import { DEFAULT_CURRENCY_ABREVIATURE } from "features/Contactos/constants/index"
import useCuentasContables from "features/Tesoreria/hooks/useCuentasContables"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { CREAR_FACTURA_RECURRENTE } from "routes/RoutePaths"
import { setCurrency } from "../../Documentos/redux/documentosSlice"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { getDefaultCurrency } from "../redux/selectors/newDocumentoSettingsSelectors"
import {
  clearNewDocumentoSettingsState,
  setShowDocumentoCreadoModal,
} from "../redux/slices/newDocumentoSettingsSlice"
import {
  clearNewDocumentoState,
  fetchNextNumero,
  newDocumentoSelectorDoc,
  stateConvertirNextDoc,
} from "../redux/slices/newDocumentoSlice"

const TIPO_DOCUMENTO = {
  0: {
    name: "presupuesto",
    path: "/crear-presupuesto",
  },
  1: {
    name: "pedido",
    path: "/crear-pedido",
  },
  2: {
    name: "albarán",
    path: "/crear-albaran",
  },
  3: {
    name: "factura",
    path: "/crear-factura",
  },
  4: {
    name: "factura",
    path: "/crear-factura-recurrente",
  },
}

const DocumentoCreado = ({
  redirectOnCreate,
  isLibrado,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const history = useHistory()
  const { comesFromMdf } = useSelector(newDocumentoSelector)
  const objetoDocumento = useSelector(newDocumentoSelectorDoc)
  const dispatch = useDispatch()
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
  const SIGUIENTE_DOCUMENTO = TIPO_DOCUMENTO[objetoDocumento.tipoDocumento + 1]
  const defaultDivisa = useSelector(getDefaultCurrency)

  const { getCuentaContablePorDefecto } = useCuentasContables()
  const { cuentasContablesEmpresas: listaDeCuentas } =
    useCuentaContableCuentaVenta()
  const cuentaPorDefecto = listaDeCuentas?.find(
    (element) =>
      element?.cuentaContableEmpresaBase?.id ===
      getCuentaContablePorDefecto(CATEGORIA_CUENTA_CONTABLE_ENUM.VENTA)
  )

  const createNextDocumento = () => {
    dispatch(clearNewDocumentoState())
    dispatch(clearNewDocumentoSettingsState(cuentaPorDefecto))
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    dispatch(fetchNextNumero())
    // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa...
    dispatch(setShowDocumentoCreadoModal(false))
    dispatch(setCurrency(defaultDivisa))
    // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa...
    localStorage.setItem("NextDocument", true)
  }

  const goBack = () => {
    dispatch(setCurrency(defaultDivisa || DEFAULT_CURRENCY_ABREVIATURE))
    if (comesFromMdf) {
      window.location.replace(`${window.location.origin}/`)
    } else {
      redirectOnCreate?.()
    }
  }

  const handleConvertir = () => {
    // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa...
    dispatch(stateConvertirNextDoc(false))
    history.push(SIGUIENTE_DOCUMENTO.path)
  }

  return (
    <div className='container pl-5 pr-5 d-flex flex-column align-items-center'>
      <div className='circle-gray'>
        <div className='circle-gray__intern'>
          <FontAwesomeIcon
            icon={["fal", "check"]}
            className='big-check-icon'
          />
        </div>
      </div>

      <h5 className='mt-2 text-center'>
        {!history.location?.pathname?.includes(CREAR_FACTURA_RECURRENTE)
          ? t("nextDoc.docCreateExit")
          : t("nextDoc.factCreateExit")}
      </h5>

      <div className='mt-4 w-100'>
        {isLibrado !== true && (
          <>
            {objetoDocumento?.tipoDocumento !== 3 && (
              <div>
                <Button
                  className='tw-w-full tw-py-4 !tw-bg-secondary hover:!tw-bg-secondary-over !tw-border-none tw-cursor-pointer'
                  onClick={handleConvertir}
                >
                  {t("crear.facturaRec.modal.convertLabel")}
                  {SIGUIENTE_DOCUMENTO.name}
                </Button>
              </div>
            )}
          </>
        )}

        <div className='mt-3'>
          <Button
            className='tw-w-full tw-py-4 !tw-bg-primary'
            onClick={goBack}
          >
            {t("crear.facturaRec.modal.endLabel")}
          </Button>
        </div>

        <div className='mt-2 w-100 d-flex justify-content-center'>
          <Button
            className='text'
            onClick={createNextDocumento}
          >
            <b> {t("crear.facturaRec.modal.createNewLabel")}</b>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default DocumentoCreado
